export default __webpack_public_path__ + "static/media/3.8b8d2746.jpg";